<template>
  <div>
    <b-button
      v-b-modal.numeroGuru
      class="ml-2"
      variant="primary"
      @click="clearForm"
    >
      Novo Número
    </b-button>
    <b-card>
      <b-overlay
        :show="load"
        variant="transparent"
      >
        <b-table
          :items="items"
          :fields="fields"
        >
          <template #cell(acoes)="data">
            <b-row align-h="center">
              <b-col cols="auto">
                <feather-icon
                  icon="ToolIcon"
                  class="cursor-pointer"
                  @click="editNumeroGuru(data.item.id)"
                />
              </b-col>
              <b-col cols="auto">
                <feather-icon
                  icon="XIcon"
                  class="iconeX cursor-pointer"
                  @click="removeNumeroGuru(data.item.id)"
                />
              </b-col>
            </b-row>
          </template>
        </b-table>
      </b-overlay>
    </b-card>
    <b-modal
      id="numeroGuru"
      ref="numeroGuruModal"
      :title="numeroGuruID ? 'Editar Número' : 'Cadastrar Número'"
      :ok-title=" numeroGuruID ? 'Atualizar' : 'Cadastrar'"
      cancel-title="Cancelar"
      cancel-variant="danger"
      no-close-on-backdrop
      @ok="numeroGuruID ? updateNumeroGuru() : submit()"
      @cancel="clearForm"
    >
      <b-row>
        <b-col>
          <label><strong>Nome: </strong></label>
          <b-form-input
            v-model="numeroGuru.nome"
            type="text"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label><strong>Número: </strong></label>
          <b-form-input
            v-model="numeroGuru.numero"
            type="text"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label><strong>Limite Máximo: </strong></label>
          <b-form-input
            v-model="numeroGuru.limite_diario"
            type="number"
            min="0"
            step="any"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label class="mt-1 mr-1"><strong>Tipo Número:</strong></label>
          <v-select
            v-model="numeroGuru.tipo"
            :options="optionsTipoNumeros"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label class="mt-1 mr-1"><strong>Plataforma:</strong></label>
          <v-select
            v-model="numeroGuru.plataforma"
            :options="optionsPlataforma"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            label="Ativo:"
            class="mt-1 mr-1"
          >
            <b-form-checkbox
              v-model="numeroGuru.ativo"
              switch
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import {
  BCol,
  BRow,
  BFormInput,
  BCard,
  BTable,
  BButton,
  BOverlay,
  BFormCheckbox,
  BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import axios from '@/../axios-auth'

export default {
  components: {
    BCol,
    BRow,
    BFormInput,
    BCard,
    BTable,
    BButton,
    BOverlay,
    BFormCheckbox,
    BFormGroup,
    vSelect,
  },
  data() {
    return {
      items: [],
      numeroGuruID: null,
      fields: [
        { key: 'plataforma', label: 'PLATAFORMA', class: 'text-center' },
        { key: 'nome', label: 'NOME', class: 'text-center' },
        { key: 'numero', label: 'NÚMERO', class: 'text-center' },
        { key: 'tipo', label: 'TIPO', class: 'text-center' },
        { key: 'limite_diario', label: 'LIMITE MÁXIMO', class: 'text-center' },
        { key: 'ativo', label: 'ATIVO', class: 'text-center' },
        { key: 'acoes', label: 'AÇÕES', class: 'text-center' },
      ],
      numeroGuru: {
        numero: '',
        nome: '',
        plataforma: '',
        tipo: '',
        ativo: true,
        parametros: {
          channel_id: 1231414323123, // pode mudar dependendo do que a TSURU retornar como parametros
        },
      },
      optionsPlataforma: [
        'TSURU',
        'Evolution',
      ],
      optionsTipoNumeros: [
        'ATIVO',
        'RECEPTIVO',
        'OFICIAL',
      ],
      load: true,
    }
  },
  created() {
    this.getNumerosPlataformas()
  },
  methods: {
    clearForm() {
      this.numeroGuru.nome = ''
      this.numeroGuru.numero = ''
      this.numeroGuru.plataforma = ''
      this.numeroGuru.tipo = ''
      this.numeroGuru.limite_diario = ''
      this.numeroGuruID = null
    },
    submit() {
      this.load = true
      axios.post('/api/v1/numeros_plataformas/store', this.numeroGuru)
        .then(() => {
          this.clearForm()
          this.getNumerosPlataformas()
          this.$swal({
            title: 'Novo Número cadastrado com sucesso!',
            icon: 'success',
            showConfirmButton: false,
          })
        })
        .catch(error => {
          if (error.response) {
            this.clearForm()
            this.getNumerosPlataformas()
            this.$swal({
              title: 'Ops, erro ao cadastrar um novo número',
              icon: 'error',
              text: error.response.data.mensagem,
              showConfirmButton: false,
              timer: 1500,
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          }
        })
    },
    getNumerosPlataformas() {
      this.load = true
      axios.get('api/v1/numeros_plataformas')
        .then(res => {
          this.items = res.data.dados.map(item => ({
            ...item,
            ativo: item.ativo ? 'Sim' : 'Não',
          }))
          this.load = false
        })
        .catch(error => {
          this.load = false
          if (error.response) {
            this.clearForm()
            this.$swal({
              title: 'Erro em receber os números',
              text: error.response.data.mensagem,
              icon: 'error',
              showConfirmButton: false,
              timer: 1500,
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          }
        })
    },
    editNumeroGuru(id) {
      this.load = true
      this.numeroGuruID = id
      axios.get(`api/v1/numeros_plataformas/edit/${id}`)
        .then(res => {
          this.load = false
          this.numeroGuru = res.data.dados
          this.$refs.numeroGuruModal.show()
        })
        .catch(error => {
          this.load = false
          if (error.response) {
            this.clearForm()
            this.$swal({
              title: 'Ops, algo deu errado',
              text: error.response.data.mensagem,
              icon: 'error',
              showConfirmButton: false,
              timer: 1500,
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          }
        })
    },
    updateNumeroGuru() {
      this.load = true
      axios.put(`api/v1/numeros_plataformas/update/${this.numeroGuruID}`, this.numeroGuru, {
        headers: {
          Authorization: 'Bearer '.concat(localStorage.getItem('token')),
          accept: 'application/json',
        },
      })
        .then(() => {
          this.clearForm()
          this.getNumerosPlataformas()
          this.$swal({
            title: 'Número atualizado com sucesso!',
            icon: 'success',
            timer: 1500,
            showConfirmButton: false,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        })
        .catch(error => {
          if (error.response) {
            this.clearForm()
            this.getNumerosPlataformas()
            this.$swal({
              title: 'Ops, algo não foi possível atualizar =(',
              text: error.response.data.mensagem,
              icon: 'error',
              timer: 1500,
              showConfirmButton: false,
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          }
        })
    },
    removeNumeroGuru(id) {
      this.$swal({
        title: 'Deseja excluir esse número?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, excluir!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          axios.delete(`api/v1/numeros_plataformas/destroy/${id}`)
            .then(() => {
              this.clearForm()
              this.getNumerosPlataformas()
              this.$swal({
                title: 'Número deletado com sucesso!',
                icon: 'success',
                timer: 1500,
                showConfirmButton: false,
              })
            })
            .catch(() => {
              this.clearForm()
              this.getNumerosPlataformas()
              this.$swal({
                title: 'Ops, algo deu errado',
                icon: 'error',
                timer: 1500,
                showConfirmButton: false,
              })
            })
        }
      })
    },
  },
}
</script>
